module.exports = __webpack_public_path__ + "img/ios-icon.92990146.svg";